import { render } from "./PushDialog.vue?vue&type=template&id=94643cca&scoped=true"
import script from "./PushDialog.vue?vue&type=script&lang=js"
export * from "./PushDialog.vue?vue&type=script&lang=js"

import "./PushDialog.vue?vue&type=style&index=0&id=94643cca&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94643cca"]])

export default __exports__